const states = {};

export function createState(id, defaultValue = null, defaultOnCHange = null) {
  if (states[id] === undefined) {
    states[id] = {
      id,
      value: defaultValue,
      subs: new Set(),
    };
  }

  const state = states[id];

  function get() {
    return state.value;
  }

  function set(value = null) {
    state.value = value;
    state.subs.forEach((sub) => sub(value));
  }

  function subscribe(onCHange) {
    state.subs.add(onCHange)
  }

  function unsubscribe(onCHange) {
    state.subs.delete(onCHange)
  }

  if (defaultOnCHange) subscribe(defaultOnCHange);

  return {
    get,
    set,
    subscribe,
    unsubscribe,
  };
}

export default {
  createState,
};
